import {
  PRIORITY_TARGET_REGISTERED,
  PRIORITY_TARGET_UNREGISTERED,
  SAVE_PRIORITY_TARGET_SUCCESS,
  SAVE_PRIORITY_TARGET_FAIL,
  PRIORITY_TARGET_CHECK_OK,
  PRIORITY_TARGET_CHECK_RESET,
  PRIORITY_TARGET_CHECK_FAIL
  
} from "../actions/planningSheet";

const initialState = {
  subTitle:"",
  printDate:"",
  serialNumber:"",
  grade:"",
  classNumber:"",
  name:"",
  targetSettings: [],
  number :"",
  updateTargetSettings:[],
  priorityTargets: [],
  stickerList: [],
  message: "",
  gradeRange: {},
  confirmSaveCheck: false
};

const planningSheet = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRIORITY_TARGET_REGISTERED:
      return{
        subTitle: payload.subTitle,
        printDate: payload.printDate,
        serialNumber: payload.serialNumber,
        grade: payload.grade,
        classNumber: payload.classNumber,
        name: payload.name,
        targetSettings: payload.targetSettings,
        number : payload.number,
        updateTargetSettings: payload.updateTargetSettings,
        priorityTargets: payload.priorityTargets,
        stickerList: payload.stickerList,
        gradeRange: payload.gradeRange
      };
    case PRIORITY_TARGET_UNREGISTERED:
      return{
        ...state,
        error: payload.error
      };
    case SAVE_PRIORITY_TARGET_SUCCESS:
      return {
        ...state,
        message: payload.message,
      };
    case SAVE_PRIORITY_TARGET_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case PRIORITY_TARGET_CHECK_OK:
      return {
        ...state,
        confirmSaveCheck: true
      };
    case PRIORITY_TARGET_CHECK_RESET:
      return {
        ...state,
        confirmSaveCheck: false
      }; 
    case PRIORITY_TARGET_CHECK_FAIL:
      return {
        ...state,
        error: payload.error
      };    
    default:
      return {
        ...state
      };
  }
};

export default planningSheet;
